import { FC } from 'react';

import { Alert, Box, Link, Typography } from '@mui/material';
import clsx from 'clsx';
import { useBreakpoints } from 'hooks';

import { AIAssistantAlertCard } from 'components/BusinessToolForm/components/AIAssistantAlertCard';

import { IAlertComponentProps } from './types';
import { BottomSliderControlled } from '../BottomSlider';

import styles from './AlertComponent.module.scss';

import scssVariables from 'styles/sass-variables.module.scss';

const borderMap: Record<any, string> = {
  error: scssVariables.red_default,
  warning: scssVariables.orange_default,
  info: scssVariables.blue_default,
  success: scssVariables.green_default,
  default: scssVariables.grey_200,
};

export const AlertComponent: FC<IAlertComponentProps> = (props) => {
  const { title, message, className, sx, severity, children, ...restProps } = props;
  const { isMobile } = useBreakpoints();

  if (isMobile && message === 'Please fill out required fields (marked with an asterisk) in "Overview" chapter.') {
    return (
      <Alert
        {...restProps}
        severity={severity}
        className={clsx(styles.alert, className)}
        sx={{ ...sx, border: `1px solid ${borderMap[severity ?? 'default']}` }}
      >
        <Typography variant="h6">Not Enough Context!</Typography>
        <BottomSliderControlled
          renderController={(onClick) => (
            <Box component="span">
              Please fill out required fields (marked with an asterisk) in{' '}
              <Link className={styles.mobileLink} onClick={onClick}>
                "Overview"
              </Link>{' '}
              chapter.
            </Box>
          )}
        >
          {({ onClose }) => <AIAssistantAlertCard onCardClose={onClose} />}
        </BottomSliderControlled>
      </Alert>
    );
  }

  return (
    <Alert
      {...restProps}
      severity={severity}
      className={clsx(styles.alert, className)}
      sx={{ ...sx, border: `1px solid ${borderMap[severity ?? 'default']}` }}
    >
      {title && <Typography variant="h6">{title}</Typography>}
      {message && <Box component="span">{message}</Box>}
      {children}
    </Alert>
  );
};
